// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorAccountUpsearchRequestModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorAccountUpsearchRequestModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorAccountUpsearchRequestModel.discriminator = undefined;
EnterpriseCoordinatorAccountUpsearchRequestModel.additionalProperties = false;
EnterpriseCoordinatorAccountUpsearchRequestModel.attributeTypeMap = [
    {
        "name": "hierarchyExternalIdTypes",
        "baseName": "hierarchyExternalIdTypes",
        "type": ""
    },
    {
        "name": "sourceId",
        "baseName": "sourceId",
        "type": "number"
    },
    {
        "name": "patientData",
        "baseName": "patientData",
        "type": "UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel"
    },
    {
        "name": "accountData",
        "baseName": "accountData",
        "type": "UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel"
    },
    {
        "name": "diagnosisSessionData",
        "baseName": "diagnosisSessionData",
        "type": "EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel"
    },
    {
        "name": "payorData",
        "baseName": "payorData",
        "type": ""
    },
    {
        "name": "pharmacyData",
        "baseName": "pharmacyData",
        "type": ""
    },
    {
        "name": "prescriberData",
        "baseName": "prescriberData",
        "type": ""
    },
    {
        "name": "prescriptionData",
        "baseName": "prescriptionData",
        "type": ""
    },
    {
        "name": "siteData",
        "baseName": "siteData",
        "type": ""
    },
    {
        "name": "surveySessionData",
        "baseName": "surveySessionData",
        "type": ""
    },
];
//# sourceMappingURL=enterpriseCoordinatorAccountUpsearchRequestModel.js.map